import React, { createContext, useContext, useState } from "react";
import { useNotification } from "./NotificationContext";

export const ScheduleContext = createContext();

export const ScheduleContextProvider = ({ children }) => {
  const [specialization, setSpecialization] = useState("");
  const [specializationType, setSpecializationType] = useState("");
  const [selectedSlots, setSelectedSlots] = useState({});
  const { notify } = useNotification();

  const timeToMinutes = (time, meridian) => {
    const [hours, minutes] = time.split(":").map(Number);
    let totalMinutes = hours * 60 + minutes;

    if (meridian === "PM" && hours !== 12) {
      totalMinutes += 12 * 60;
    } else if (meridian === "AM" && hours === 12) {
      totalMinutes = minutes;
    }

    return totalMinutes;
  };

  const isTimeOverlapping = (
    day,
    slots,
    currentIndex,
    newTime,
    newMeridian
  ) => {
    if (!newTime) return false;

    const currentTimeMinutes = timeToMinutes(newTime, newMeridian);
    const currentEndTimeMinutes = currentTimeMinutes + 60;

    return slots[day].some((slot, index) => {
      if (index === currentIndex || !slot.start) return false;

      const slotTimeMinutes = timeToMinutes(slot.start, slot.meridian);
      const slotEndTimeMinutes = slotTimeMinutes + 60;

      return (
        (currentTimeMinutes >= slotTimeMinutes &&
          currentTimeMinutes < slotEndTimeMinutes) ||
        (currentEndTimeMinutes > slotTimeMinutes &&
          currentEndTimeMinutes <= slotEndTimeMinutes) ||
        (currentTimeMinutes <= slotTimeMinutes &&
          currentEndTimeMinutes >= slotEndTimeMinutes)
      );
    });
  };

  const updateSpecialization = (spec) => {
    setSpecialization((prevSpec) => {
      const newSpec = prevSpec === spec ? "" : spec;
      // Reset specializationType when specialization changes
      if (newSpec !== prevSpec) {
        setSpecializationType("");
      }
      return newSpec;
    });
  };

  const updateSpecializationType = (type) => {
    setSpecializationType(type);
  };

  const validateTimeSlot = (day, slots, index, newTime, newMeridian) => {
    if (isTimeOverlapping(day, slots, index, newTime, newMeridian)) {
      notify.error(
        "This time slot overlaps with another slot. Please choose a different time."
      );
      return false;
    }
    return true;
  };

  const updateSlotForDay = (day, slots) => {
    setSelectedSlots((prevSlots) => ({
      ...prevSlots,
      [day]: slots,
    }));
  };

  return (
    <ScheduleContext.Provider
      value={{
        specialization,
        specializationType,
        selectedSlots,
        updateSpecialization,
        updateSpecializationType,
        updateSlotForDay,
        validateTimeSlot,
        isTimeOverlapping,
      }}
    >
      {children}
    </ScheduleContext.Provider>
  );
};

export const useSchedule = () => useContext(ScheduleContext);
